<template>
  <two-column-layout :class="rootClass">
    <pogs-list-patient slot="sidebar"
                       :patients="patients"
                       :patientCount="computedPatientCount"
                       @hideNav="hideNav"/>

      <router-view slot="content" name="patientProfilePreview" />
  </two-column-layout>
</template>

<script>
  import {mapActions ,mapGetters, mapMutations} from 'vuex'

  import {
    GETTER_PATIENTS,
    ACTION_LOAD_PATIENT_LIST,
    ACTION_LOAD_PATIENT_COUNT,
    ACTION_LOAD_ADMITTED_PATIENT_COUNT,
    ACTION_LOAD_OPENCASE_PATIENT_COUNT,
  } from '../../../store/modules/patients'

  import {GETTER_SHOW_PREVIEW, MUTATE_TOGGLE_PREVIEW, MUTATE_SHOW_PREVIEW} from '../../../store/modules/shared'
  import PogsListPatient from './pogs-list--patient'

  import Permissions from '../../../mixins/permissions-mixin'
  import {ROOT_PATIENT_PERMISSIONS} from '../../../reference/pogs-functional-permissions'

  export default {
    mixins: [Permissions],
    components: {
      PogsListPatient,
    },
    data(){
      return{
        numOfPatients: null,
        numOfAdmittedPatients: null,
        numOfPatientWithOpenCase: null
      }
    },
    computed: {
      ...mapGetters({
        isPreview: GETTER_SHOW_PREVIEW,
        patients: GETTER_PATIENTS
      }),
      rootClass(){
        if(this.$route.params.patientid){
          this.setPreview(true)
        }else{
          this.setPreview(false)
        }
        return this.isPreview ? 'show-content':'hide-content'
      },
      computedPatientCount() {
        return {
          all: this.numOfPatients,
          admitted: this.numOfAdmittedPatients,
          withOpenCase: this.numOfPatientWithOpenCase
        }
      }
    },
    methods: {
      ...mapMutations({
        togglePreview: MUTATE_TOGGLE_PREVIEW,
        setPreview: MUTATE_SHOW_PREVIEW
      }),
      ...mapActions({
        loadNumOfPatients: ACTION_LOAD_PATIENT_COUNT,
        loadNumOfAdmittedPatients: ACTION_LOAD_ADMITTED_PATIENT_COUNT,
        loadNumOfOpenCasePatients: ACTION_LOAD_OPENCASE_PATIENT_COUNT
      }),
      hideNav() {
          this.$emit('hideNav')
      }
    },
    mounted() {
      if(this.hasPermissionFor(ROOT_PATIENT_PERMISSIONS)){
        console.log('The user has access to patient page')
      }else{
        console.log('The user has no access to patient page')
      }

      this.$store.dispatch(ACTION_LOAD_PATIENT_LIST)
        .then((data) => {
          console.log("Patient list has been successfully loaded!")
        });


      this.loadNumOfPatients()
        .then((result) => {
          this.numOfPatients = result.numOfPatients
        });

      this.loadNumOfAdmittedPatients()
        .then((result) => {
          this.numOfAdmittedPatients = result.numOfAdmittedPatients
        });


      this.loadNumOfOpenCasePatients()
        .then((result) => {
          this.numOfPatientWithOpenCase = result.numOfPatientWithOpenCase
        });

    }
  }
</script>

  <style lang="scss">

    @media (max-width: 850px) {
      .show-content .content {
          grid-area: app__status !important;
      }
    }
    @media (max-width: 376px) {
      .patient-data__details > .patient-data__meta {
        padding-top: 5px;
        grid-template-columns: unset;
        grid-template-rows: 20px 20px;
        grid-column-gap: 0;
      }
    }
  </style>